







































































import {
  Vue, Component, Prop, Emit, Watch,
} from 'vue-property-decorator';
import { VbDirectives } from '@/shared/directive/vb-directives';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import { VMoney } from 'v-money';
import Rules from '@/shared/rules/rules';
import RuleScript from '@/domain/scripts/entity/rule-script.entity';
import LabelSlot from '@/shared/slots/label-slot.component.vue'
import RuleType from './rule-type.json';

@Component({
  components: {
    LabelSlot,
  },
})
export default class ScriptContent extends Vue {
  @Prop({
    required: true,
  })
  ruleScript!: RuleScript;

  @Prop({
    required: true,
    default: false,
  })
  editModeValue!: boolean;

  @Prop({
    required: true,
  })
  businessUnitId!: string;

  @Prop({
    required: true,
    default: false,
  })
  previewModeValue!: boolean;

  valid: boolean = false;

  rules: Rules = new Rules();

  ref: any = this.$refs;

  ruleToEdit: RuleScript = RuleScript.of({});

  ruleTypes = RuleType;

  updateRuleScript() {
    this.$emit('rule', this.ruleToEdit)
    this.$emit('valid', this.valid)
  }

  @Watch('ruleScript')
  onRuleScriptChange() {
    if (this.ruleScript) {
      this.ruleToEdit = this.ruleScript;
    }
  }

  created() {
    if (this.ruleScript) {
      this.ruleToEdit = this.ruleScript;
    }
  }
}
